"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./_useLocale-8e23751a.js");require("react"),require("./IntlContext-381f3ce4.js"),exports.useLocale=e.useLocale;
